import { useContext } from 'react';
import { ChatWrapperContext } from './Provider';
export const useChatWrapperContext = () => useContext(ChatWrapperContext);
